import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

export interface IProductDetailEditTextData {
  title: string;
  description: string;
  labelData: string;
  tagData: string;
  isSuperAdmin: string;
  decorationType?: string;
  oldDecorationTypeTag?: string;
}

@Component({
  selector: 'app-product-detail-edit-text',
  templateUrl: './product-detail-edit-text.component.html',
  styleUrls: ['./product-detail-edit-text.component.css']
})
export class ProductDetailEditTextComponent implements OnInit {

  constructor(
    public dialogRef: MatDialogRef<ProductDetailEditTextComponent>,
    @Inject(MAT_DIALOG_DATA) public data: IProductDetailEditTextData
  ) { }

  productLabels: any[] = [];
  productTags: any[] = [];
  showDecorationTypeChangeInfo: boolean = false;

  ngOnInit() {
    if (this.data.labelData && this.data.labelData) {
      let arr = JSON.parse(this.data.labelData);
      if (arr.length > 0 && arr[0].text) {
        this.productLabels = arr;
      } else {
        this.productLabels.push({ text: '', backgroundColor: '', textColor: '' });
      }
    } else {
      this.productLabels.push({ text: '', backgroundColor: '', textColor: '' });
    }

    // Initialize tags - always add current decoration type as first tag in edit mode
    if (this.data.tagData && this.data.tagData) {
      let arr = JSON.parse(this.data.tagData);

      // Remove any existing decoration type tags (first tag is assumed to be decoration type from previous save)
      // Keep only user's custom tags (skip first tag if it exists, as it's the old decoration type)
      let userTags = arr.length > 0 ? arr.slice(1) : [];
      // Filter out empty tags
      userTags = userTags.filter(tag => tag.tagtext && tag.tagtext.trim() !== '');

      // Always add current decoration type as first tag
      if (this.data.decorationType) {
        this.productTags = [
          { tagtext: this.data.decorationType, isDefault: true },
          ...userTags
        ];
      } else {
        // No decoration type, just show user tags
        this.productTags = userTags.length > 0 ? userTags : [{ tagtext: '' }];
      }
    } else {
      // No tags exist, add decoration type as first tag if available
      if (this.data.decorationType) {
        this.productTags = [{ tagtext: this.data.decorationType, isDefault: true }];
      } else {
        this.productTags = [{ tagtext: '' }];
      }
    }

    // Check if decoration type has changed and set flag to show info message
    if (this.data.decorationType && this.data.oldDecorationTypeTag &&
        this.data.decorationType !== this.data.oldDecorationTypeTag) {
      this.showDecorationTypeChangeInfo = true;
    }
  }

  onClose() {
    // Prepare tags to save: decoration type (if exists) + user's custom tags
    let tagsToSave = [];

    // Add decoration type as first tag (without isDefault flag - for database)
    if (this.data.decorationType) {
      tagsToSave.push({ tagtext: this.data.decorationType });
    }

    // Add user's custom tags (filter out empty ones and the default tag)
    const userTags = this.productTags
      .filter(tag => !tag.isDefault && tag.tagtext && tag.tagtext.trim() !== '')
      .map(tag => ({ tagtext: tag.tagtext })); // Remove isDefault flag from user tags too

    tagsToSave = [...tagsToSave, ...userTags];

    const payload = {
      data: this.data,
      labelData: JSON.stringify(this.productLabels),
      tagData: JSON.stringify(tagsToSave)
    };
    this.dialogRef.close(payload);
  }

  fn_AddLabel() {
    if (this.productLabels.length >= 3)
      return;

    this.productLabels.push({ text: '', backgroundColor: '', textColor: '' });
    this.productLabels = [...this.productLabels];
  }

  fn_AddTag() {
    if (this.productTags.length >= 15)
      return;

    this.productTags.push({ tagtext: '' });
    this.productTags = [...this.productTags];
  }

  fn_RemoveLabel(index: number) {
    this.productLabels.splice(index, 1);
  }

  fn_RemoveTag(index: number) {
    // Prevent deletion of default tag (decoration type - first tag with isDefault: true)
    if (this.productTags[index].isDefault) {
      return;
    }
    this.productTags.splice(index, 1);
  }

  onColorInputChange(event: any, item: any, type: string) {
    const color = event.target.value;
    if (type === 'background') {
      item.backgroundColor = color;
    } else if (type === 'text') {
      item.textColor = color;
    }
  }
}
